import { Agenzia } from './agenzia';
import { Compagnia } from './compagnia';
import { Contraente } from './contraente';
import { AltroSoggetto } from './altro-soggetto';
import { Fabbricato } from './fabbricato';
import { Ramo } from './ramo';
import { Model } from './model';
import { ModelloCompagnia } from './modello-compagnia';


export class Polizza extends Model {
  static apiUrl: string = "polizze";
  
  compagnia: Compagnia;
  compagnia_id: number;

  numero: string;
  sottocompagnia: string;

  contraente: Contraente;
  contraente_type: string;
  contraente_id: number;

  data_decorrenza: moment.Moment;
  cga: ModelloCompagnia;
  cga_id: number;

  fabbricato: Fabbricato;
  fabbricato_id: number;

  agenzia: Agenzia;
  ramo: Ramo;



  deserialize(input: any): Polizza {
    let retV: Polizza = new Polizza();
    retV = super.deserialize(input) as Polizza;

    if (input?.compagnia) {
      retV.compagnia = new Compagnia().deserialize(input.compagnia);
    }

    if (input?.agenzia) {
      retV.agenzia = new Agenzia().deserialize(input.agenzia);
    }

    if (input?.ramo) {
      retV.ramo = new Ramo().deserialize(input.ramo);
    }

    if (input?.contraente) {
      if (input?.contraente_type == 'App\\AltroSoggetto') {
        retV.contraente = new AltroSoggetto().deserialize(input.contraente);
      }

      else if (input?.contraente_type == 'App\\Fabbricato') {
        retV.contraente = new Fabbricato().deserialize(input.contraente);

      }
    }

    if (input?.fabbricato) {
      retV.fabbricato = new Fabbricato().deserialize(input.fabbricato);
    }

    return retV;
  }

  public getHumanIdentifier() {
    let result = this.numero;
    if (this.compagnia)
      result += ' ' + this.compagnia.humanIdentifier;

    return result;
  }
}
